"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomersModule = /** @class */ (function () {
    function CustomersModule() {
    }
    return CustomersModule;
}());
exports.CustomersModule = CustomersModule;
